import React from "react";
import PropTypes from "prop-types";
import styles from "@/components/CustomComponents/YourRoutine/index.module.scss";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { renderRichText } from "@/utils/formatters";

const YourRoutine = ({ routineData }) => {
  if (!routineData) return null;
  const {
    heading,
    images = [],
    showLineTop = false,
    showLineBelow = false,
    hideContentOn = "both",
  } = routineData || {};
  const sortedImageData = images?.sort((a, b) => a.number - b.number) || [];
  const router = useRouter();
  const { locale } = router;
  let hideContent = false;

  switch (locale) {
    case "vn":
      hideContent = hideContentOn === "vn" ? true : false;
      break;

    case "en":
      hideContent = hideContentOn === "en" ? true : false;
      break;

    default:
      hideContent = false;
  }

  const contentClass = hideContent ? "hidden" : "";
  return (
    <div className={contentClass}>
      <div className={styles.wrapper}>
        {heading && <div className="titleContainer">{heading}</div>}
        <div className="w-full max-[999px]:px-2">
          {showLineTop && <hr className="koh-horizontalrule-block my-10" />}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 ">
            {sortedImageData.map(({ fields, sys }) => (
              <div
                key={sys?.id}
                className=" koh-meterial-category-items cursor-pointer w-full mt-10 md:mt-5"
              >
                <Link
                  href={fields.src || "#"}
                  onClick={e => {
                    if (!fields.src) e.preventDefault();
                  }}
                >
                  <div class="group inline-block cursor-pointer w-full ">
                    <Image
                      src={fields.imageUrl}
                      alt={fields.alt}
                      width={0}
                      height={0}
                      className="w-full h-auto image-section object-cover transition-all duration-300 ease-in-out hover:scale-105 hover:-translate-y-1 hover:shadow-xl"
                    />

                    <div className="p-2 flex flex-col justify-items-center w-full">
                      <div className="desc-num w-full">
                        {fields.number ? (
                          <i className="number">
                            <span className="label-class transition-all duration-300 group-hover:text-white">
                              {fields.number}
                            </span>
                          </i>
                        ) : null}
                        {fields.name ? (
                          <p className="number-name font-bold transition-all duration-300 group-hover:text-gray-400 pl-9">
                            {fields.name}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </Link>
                <div className="item-description cursor-auto w-full">
                  {fields?.richTextDescription ? (
                    <div className={`koh-walking-bath-fb-desc-format ${fields.showNumber ? "ml-10" : "null"}`}>
                      {renderRichText(fields.richTextDescription, locale)}
                    </div>
                  ) : fields.description ? (
                    <p
                      className={`koh-walking-bath-fb-desc-format ${fields.showNumber ? "ml-10" : "null"}`}
                    >
                      {fields.description}
                    </p>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
          {showLineBelow && <hr className="koh-horizontalrule-block mt-10" />}
        </div>
      </div>
    </div>
  );
};

YourRoutine.propTypes = {
  routineData: PropTypes.object,
};

YourRoutine.defaultProps = {
  routineData: {},
};

export default YourRoutine;
